import { CustomSelector, ECustomSelector } from '@globalmed/atlas-ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styles from './ProvisioningTab.module.css';
import { TCreateInstitutionForm } from '../../schema';
import { InstitutionContractPeriods } from '@/forms';

/**
 * Provisioning tab of the Create Institution modal — the new institution's
 * contract periods with their seat and license counts.
 * @returns ProvisioningTab component.
 */
export const ProvisioningTab = () => {
  const { t } = useTranslation();
  const {
    formState: { isSubmitting },
  } = useFormContext<TCreateInstitutionForm>();

  return (
    <div className={styles.flexColumn}>
      {/* Decorative only */}
      <CustomSelector
        type={ECustomSelector.Select}
        labelProps={{
          label: t('admin-panel.provisioning-billing-type'),
          required: true,
        }}
        selected={undefined}
        onChange={() => {}}
        placeholder={t('create-organization-modal.institution-provisioning')}
        disabled
        sx={{ width: '100%' }}
      />
      <InstitutionContractPeriods disabled={isSubmitting} isScrollable />
    </div>
  );
};
